import iconCurso from '../../../../assets/icons/courses/iconCurso.svg';
import iconRecordNotas from '../../../../assets/icons/courses/iconRecordNotas.svg';
import iconAvancePlanEstudios from '../../../../assets/icons/courses/iconAvancePlanEstudios.svg';
import iconCertificacionesProgresivas from '../../../../assets/icons/courses/iconCertificacionesProgresivas.svg';

const courseSections = [
  {
    title: 'Mis cursos',
    icon: iconCurso,
    description:
      'Visualiza la información de tus cursos organizados por ciclo matriculado.',
    url: 'cursos/mis-cursos',
    test: 'cmp-btn-courses-mis-cursos'
  },
  {
    title: 'Record de notas',
    icon: iconRecordNotas,
    description: 'Consulta tu record de notas de los ciclos concluidos.',
    url: 'cursos/record-de-notas',
    test: 'cmp-btn-courses-record-notas'
  },
  {
    title: 'Avance de plan de estudio',
    icon: iconAvancePlanEstudios,
    description: 'Revisa tu malla curricular y el progreso de tu carrera.',
    url: 'cursos/avance-plan-de-estudios',
    test: 'cmp-btn-courses-avance-plan'
  },
  {
    title: 'Certificaciones progresivas',
    icon: iconCertificacionesProgresivas,
    description:
      'Obten y descarga certificaciones según el avance de tus cursos.',
    url: 'cursos/certificaciones-progresivas',
    test: 'cmp-btn-courses-certificaciones-progresivas'
  }
];

const sectionHeader = {
  title: 'Cursos',
  description:
    'Explora y sigue de cerca tu desarrollo académico, tus cursos y certificaciones.'
};

const subsectionHeader = [
  { id: 1, title: 'Mis cursos' },
  { id: 2, title: 'Record de notas' },
  { id: 3, title: 'Avance de plan de estudio' },
  { id: 4, title: 'Certificaciones progresivas' }
];

export default {
  courseSections,
  sectionHeader,
  subsectionHeader
};
